/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".event-tiers-modal{min-width:720px}.event-tiers-modal p{color:#607d8b}.event-tiers-modal table{width:100%;border-collapse:collapse;margin-top:20px}.event-tiers-modal td,.event-tiers-modal th{text-align:left;padding:10px 8px;border-bottom:1px solid #ddd}.event-tiers-modal th{color:#607d8b}.event-tiers-modal input{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid #cfd8dc;padding:9px}.event-tiers-modal .new-tier td{padding-top:24px}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/event.subscription.tiers/event.subscription.tiers.modal.component.scss.ngstyle.js.pre-build-optimizer.js